// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post .reactions .reactions__view {
    display: block;
    text-align: left;
    padding: 7px 5px 5px 15px;
    font-size: 16px;
}
.post .reactions .reactions__view svg {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-left: 5px;
    margin-bottom: -2px;
    color: var(--link-color);
}
.post .reactions .reactions__view .block svg {
    color: var(--danger-color-main);
}

.reactions__detail-modal .modal {
    max-width: 600px;
    padding: 40px 0; 
}

.reactions__detail {
    font-size: 18px;
    text-align: left;
    padding: 10px 30px;
}
.reactions__detail div {
    padding: 2px 0;
}

.reactions__detail svg.reaction {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-right: 5px;
    margin-bottom: -2px;
    color: var(--link-color);
}
.reactions__detail svg.reaction.block {
    color: var(--danger-color-main);
}

.post .reactions .reactions__controls {
    display: flex;
    border-top: thin solid var(--main-border-color);
    font-size: 14px;
    margin: 0 auto;
}
.post .reactions .reactions__controls .group {
    flex-grow: 1;
    text-align: center;
}
.post .reactions .reactions__controls .group a {
    display: block;
    padding: 10px 7px;
}
.post .reactions .reactions__controls .group a svg {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-left: 5px;
    margin-bottom: -2px;
    color: var(--link-color);
}
.post .reactions .reactions__controls .group a:hover svg {
    color: var(--link-highlight-color);
}


.post .reactions .reactions__controls .group.block,
.post .reactions .reactions__controls .group.share {
    border-left: thin solid var(--main-border-color);
}
.post .reactions .reactions__controls .group.block a:link,
.post .reactions .reactions__controls .group.block a:visited,
.post .reactions .reactions__controls .group.block a:active,
.post .reactions .reactions__controls .group.block svg {
    color: var(--primary-color-dark);
}
.post .reactions .reactions__controls .group.block a:hover,
.post .reactions .reactions__controls .group.block a:hover svg {
    color: var(--danger-color-main);
}

.post .reactions .reactions__controls .group a.reacted:link,
.post .reactions .reactions__controls .group a.reacted:visited,
.post .reactions .reactions__controls .group a.reacted:active,
.post .reactions .reactions__controls .group a.reacted svg {
    color: var(--success-color-main);
}

.post .reactions .reactions__controls .group a.reacted:hover,
.post .reactions .reactions__controls .group a.reacted:hover svg {
    color: var(--success-color-main-highlight);
}

.post .reactions .reactions__controls .group.block a.reacted:link,
.post .reactions .reactions__controls .group.block a.reacted:visited,
.post .reactions .reactions__controls .group.block a.reacted:active,
.post .reactions .reactions__controls .group.block a.reacted svg {
    color: var(--danger-color-main);
}

.post .reactions .reactions__controls .group.block a.reacted:hover,
.post .reactions .reactions__controls .group.block a.reacted:hover svg {
    color: var(--danger-color-main-highlight);
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/Post/PostReactions/PostReactions.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,eAAe;IACf,cAAc;AAClB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,kCAAkC;AACtC;;;AAGA;;IAEI,gDAAgD;AACpD;AACA;;;;IAII,gCAAgC;AACpC;AACA;;IAEI,+BAA+B;AACnC;;AAEA;;;;IAII,gCAAgC;AACpC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;;;IAII,+BAA+B;AACnC;;AAEA;;IAEI,yCAAyC;AAC7C","sourcesContent":[".post .reactions .reactions__view {\n    display: block;\n    text-align: left;\n    padding: 7px 5px 5px 15px;\n    font-size: 16px;\n}\n.post .reactions .reactions__view svg {\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    margin-left: 5px;\n    margin-bottom: -2px;\n    color: var(--link-color);\n}\n.post .reactions .reactions__view .block svg {\n    color: var(--danger-color-main);\n}\n\n.reactions__detail-modal .modal {\n    max-width: 600px;\n    padding: 40px 0; \n}\n\n.reactions__detail {\n    font-size: 18px;\n    text-align: left;\n    padding: 10px 30px;\n}\n.reactions__detail div {\n    padding: 2px 0;\n}\n\n.reactions__detail svg.reaction {\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    margin-right: 5px;\n    margin-bottom: -2px;\n    color: var(--link-color);\n}\n.reactions__detail svg.reaction.block {\n    color: var(--danger-color-main);\n}\n\n.post .reactions .reactions__controls {\n    display: flex;\n    border-top: thin solid var(--main-border-color);\n    font-size: 14px;\n    margin: 0 auto;\n}\n.post .reactions .reactions__controls .group {\n    flex-grow: 1;\n    text-align: center;\n}\n.post .reactions .reactions__controls .group a {\n    display: block;\n    padding: 10px 7px;\n}\n.post .reactions .reactions__controls .group a svg {\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    margin-left: 5px;\n    margin-bottom: -2px;\n    color: var(--link-color);\n}\n.post .reactions .reactions__controls .group a:hover svg {\n    color: var(--link-highlight-color);\n}\n\n\n.post .reactions .reactions__controls .group.block,\n.post .reactions .reactions__controls .group.share {\n    border-left: thin solid var(--main-border-color);\n}\n.post .reactions .reactions__controls .group.block a:link,\n.post .reactions .reactions__controls .group.block a:visited,\n.post .reactions .reactions__controls .group.block a:active,\n.post .reactions .reactions__controls .group.block svg {\n    color: var(--primary-color-dark);\n}\n.post .reactions .reactions__controls .group.block a:hover,\n.post .reactions .reactions__controls .group.block a:hover svg {\n    color: var(--danger-color-main);\n}\n\n.post .reactions .reactions__controls .group a.reacted:link,\n.post .reactions .reactions__controls .group a.reacted:visited,\n.post .reactions .reactions__controls .group a.reacted:active,\n.post .reactions .reactions__controls .group a.reacted svg {\n    color: var(--success-color-main);\n}\n\n.post .reactions .reactions__controls .group a.reacted:hover,\n.post .reactions .reactions__controls .group a.reacted:hover svg {\n    color: var(--success-color-main-highlight);\n}\n\n.post .reactions .reactions__controls .group.block a.reacted:link,\n.post .reactions .reactions__controls .group.block a.reacted:visited,\n.post .reactions .reactions__controls .group.block a.reacted:active,\n.post .reactions .reactions__controls .group.block a.reacted svg {\n    color: var(--danger-color-main);\n}\n\n.post .reactions .reactions__controls .group.block a.reacted:hover,\n.post .reactions .reactions__controls .group.block a.reacted:hover svg {\n    color: var(--danger-color-main-highlight);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
